import usePagination from "src/customHooks/usePagination";
import { useGetCreditVouchersQuery, useCountCreditVouchersQuery } from "../credit-voucher.service";
import PageHeader from "src/components/pageHeader";
import { CreditVoucher } from "../types/credit-voucher.entity";
import CreditVouchersTable from "../components/credit-voucher-table";
import { CreditVouchersTableSkeleton } from "../components/CreditVouchersTableSkeleton";
import Pagination from "src/components/pagination";
import { Navigate } from "react-router-dom";
import PageLoading from "src/components/pageLoading";
import { CoachRecordingFilter } from "../components/credit-voucher-filter";
import { FilterCreditVouchers } from "../types";
import { FaPlus } from "react-icons/fa";
import { LinkButton } from "src/components/LinkButton";

export const CreditVouchers = () => {
  const { data, numberOfPages, currentPage, next, prev, isSuccess, isError, isLoading, isFetching, updateQuery } =
    usePagination<CreditVoucher>({
      useGetDataQuery: useGetCreditVouchersQuery,
      useCountData: useCountCreditVouchersQuery,
    });

  return (
    <div className="page_container">
      <PageHeader text="Credit Vouchers" />

      <div className="mt-4 mb-2 flex justify-end">
        <LinkButton to="/credit-vouchers/create" text="Create Vouchers" icon={FaPlus} />
      </div>

      <CoachRecordingFilter updateFilterQuery={(where: FilterCreditVouchers) => updateQuery(where)} />

      {isSuccess ? (
        <>
          {isLoading || isFetching ? (
            <div className="overflow-x-auto mb-6 -mx-2 sm:mx-0">
              <table className="min-w-[980px] sm:min-w-full border border-gray-200 divide-y divide-gray-200 text-[11px] sm:text-xs">
                <thead className="bg-gray-900 text-white text-center text-[10px] sm:text-xs">
                  <tr>
                    <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Voucher</th>
                    <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Status</th>
                    <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Type</th>
                    <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Amount</th>
                    <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Created</th>
                    <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Expiry</th>
                    <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <CreditVouchersTableSkeleton rows={10} />
                </tbody>
              </table>
            </div>
          ) : (
            <CreditVouchersTable data={data} />
          )}
          <Pagination numberOfPages={numberOfPages} currentPage={currentPage} prev={prev} next={next} isLoading={isLoading || isFetching} />
        </>
      ) : isError ? (
        <Navigate to="/505" />
      ) : (
        <PageLoading />
      )}
    </div>
  );
};
